var map = {
	"./abb-color.svg": 1727,
	"./afb-color.svg": 1728,
	"./afb.svg": 1729,
	"./alb-color.svg": 1730,
	"./alb.svg": 1731,
	"./amb-color.svg": 1732,
	"./amb.svg": 1733,
	"./bbbaidja-color.svg": 1734,
	"./bbbaidjaxxx-color.svg": 1735,
	"./bdinidjaxxx-color.svg": 1736,
	"./bimb-color.svg": 1737,
	"./bimb.svg": 1738,
	"./bkr-color.svg": 1739,
	"./bkr.svg": 1740,
	"./bmriidja-color.svg": 1741,
	"./bniaidja-color.svg": 1742,
	"./bninidja-color.svg": 1743,
	"./bninidjaxxx-color.svg": 1744,
	"./bpay-color.svg": 1745,
	"./brinidja002-color.svg": 1746,
	"./bsmdidjaxxx-color.svg": 1747,
	"./bsn-color.svg": 1748,
	"./bsn.svg": 1749,
	"./btanidjaxxx-color.svg": 1750,
	"./cenaidja-color.svg": 1751,
	"./cenaidjaxxx-color.svg": 1752,
	"./cimb-color.svg": 1753,
	"./cimb.svg": 1754,
	"./citi-color.svg": 1755,
	"./citi.svg": 1756,
	"./default-bank-icon-color.png": 1757,
	"./default-bank-icon.png": 1758,
	"./gxbank-color.svg": 1759,
	"./hlb-color.svg": 1760,
	"./hlb.svg": 1761,
	"./hsbc-color.svg": 1762,
	"./hsbc.svg": 1763,
	"./ibbkidjaxxx-color.svg": 1764,
	"./kwh-color.svg": 1765,
	"./kwh.svg": 1766,
	"./mbb-color.svg": 1767,
	"./mbb.svg": 1768,
	"./nispidjaxxx-color.svg": 1769,
	"./ocbc-color.svg": 1770,
	"./ocbc.svg": 1771,
	"./pbb-color.svg": 1772,
	"./pbb.svg": 1773,
	"./pinbidja-color.svg": 1774,
	"./rhb-b.svg": 1775,
	"./rhb-color-b.svg": 1776,
	"./rhb-color.svg": 1777,
	"./rhb.svg": 1778,
	"./scb-color.svg": 1779,
	"./scb.svg": 1780,
	"./tng-color.svg": 1781,
	"./uob-color.svg": 1782,
	"./uob.svg": 1783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;